import { useState, useEffect } from 'react';
import { getTransactionsByDate } from '../services/api';

export interface Transaction {
  tscId: number;
  tscName: string;
  tccId: number;
  tccName: string;
  tscValue: number;
  tscRecurrence: number;
  tscRecurrenceDate: string | null;
  tscDateCreated: string;
  tscVersion: number;
  tscIdInitVersion: number | null;
  usrId: number;
  tscMonth: number;
  tscYear: number;
  usrIdTransaction: number;
  usrName: string;
  tctId: 1 | 2;
  tctName: "Entrada" | "Saída";
  tscCheck: 0 | 1;
}

export const useTransactionData = (month: number, year: number, userCurrent?: string) => {
  const [transactions, setTransactions] = useState<Transaction[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        setError(null);
        const data = await getTransactionsByDate(month, year, userCurrent);
        setTransactions(data);
      } catch (err) {
        setError(err instanceof Error ? err.message : 'Erro ao carregar dados');
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [month, year, userCurrent]);

  return { transactions, loading, error };
};